import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Points from '../../../../images/pts-icon.svg';
import Arrow from '../../../../images/chart_arrow.png';

export const TitleCopy = styled.h2`
  color: inherit;
  margin-top: 1rem;
  span {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  span.points {
    display: inline-block;
    &:after {
      content: '';
      background-image: url(${Points});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      height: 2.5rem;
      width: 2.5rem;
      display: inline-block;
      bottom: 0;
      right: 0;
      margin-left: 0.25rem;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        bottom: 1rem;
      }
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 2rem;
  flex-direction: column;
  text-align: ${({ textAlignment }) => textAlignment || 'left'};

  color: ${({ theme, headingColor }) =>
    headingColor ? theme.colors[headingColor] : null};

  &.pcma {
    &:after {
      content: '';
      background-image: url(${Arrow});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      width: 120px;
      height: 52px;
      display: inline-block;
      bottom: 0;
      right: 0;
      margin-left: 0.25rem;
      left: calc(50% - 60px);
      bottom: -2.75rem;
      z-index: 1;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        width: 160px;
        height: 62px;
        left: calc(50% - 80px);
        bottom: -3rem;
      }
    }
  }
`;

export const TitleBody = styled.p`
  color: inherit;
  margin: 1rem auto;
`;

export const BodyContent = styled.div`
  text-align: ${({ textAlignment }) => textAlignment || 'left'};
  a {
    color: currentColor;
    span {
      font-size: inherit;
      font-weight: inherit;
    }
  }
  li {
    color: currentColor;
  }
`;
